import React, { useState } from 'react';

function TruncatedText({ text, maxLength, className = '' }) {
  const [isTruncated, setIsTruncated] = useState(true);

  const toggleTruncate = () => {
    setIsTruncated(!isTruncated);
  };

  // If short enough, just show it with wrapping classes
  if (!text || text.length <= maxLength) {
    return <p className={`text-gray-600 ${className} break-words break-all whitespace-normal`}>{text}</p>;
  }

  return (
    <div>
      <p className={`text-gray-600 ${className} break-words break-all whitespace-normal`}>
        {isTruncated ? `${text.slice(0, maxLength)}...` : text}
      </p>
      <button onClick={toggleTruncate} className="text-primary-500 hover:text-primary-700 font-medium mt-1 block transition-colors">
        {isTruncated ? 'Show more' : 'Show less'}
      </button>
    </div>
  );
}

export default TruncatedText;
